// Maps the number shown on a pad to the actual audio file in public/beats.
// `file` is the exact original track name (no extension) — the tracks are
// kept as-is, so to swap one just point `file` at a different filename.
const beats = [
  { id: "1", file: "70 BMP BAZA", label: "1" },
  { id: "2", file: "77 FUCKT", label: "2" },
  { id: "3", file: "80 BPM 5 ГРУПП", label: "3" },
  { id: "4", file: "82 BPM ВРЕМЯ", label: "4" },
  { id: "5", file: "91 BPM ПАКА_ПАКА", label: "5" },
  { id: "6", file: "99 BPM ah kak hochetca", label: "6" },
  { id: "7", file: "109 BPM фристайл", label: "7" },
  { id: "8", file: "115 BPM PROBEI BIT (MONOLIT)", label: "8" },
  { id: "9", file: "122 BPM УКА ГАРАГЕ", label: "9" },
  { id: "10", file: "133 BPM SELIGER", label: "10" },
  { id: "11", file: "133 BPM карбогидарт", label: "11" },
  { id: "12", file: "135 BPM save rave", label: "12" },
  { id: "13", file: "140 BPM техно", label: "13" }
]

export const bonusBeat = { id: "bonus", file: "63 BPM dimok", label: "BONUS", isBonus: true }

export default beats
